// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SideMenuAdministrator_tabs {
    display: flex;
    border-bottom: 1px solid #ddd;
}

.SideMenuAdministrator_tab {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
}

.SideMenuAdministrator_tab.active {
    border-bottom-color: #4CAF50;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/SideMenuAdministrator.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["\n.SideMenuAdministrator_tabs {\n    display: flex;\n    border-bottom: 1px solid #ddd;\n}\n\n.SideMenuAdministrator_tab {\n    padding: 10px 20px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n}\n\n.SideMenuAdministrator_tab.active {\n    border-bottom-color: #4CAF50;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
